import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { CorporateButtonsProps } from "./types";
import { ButtonAppearanceOneOf, ButtonSpacingOneOf } from 'components/cms/defaults';

export class CorporateButtonsDefinitions extends CmsReactComponent<CorporateButtonsProps> {
    static defaultProps = {};

    static schemaName = "corporate-buttons";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "buttons",
            text: "Butonlar",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "appearance",
                        mapping: {
                            type: PropertyMappingType.Object,
                            oneOf: ButtonAppearanceOneOf,
                        },
                        text: "Görünüm Tipi",
                        default: "default",
                    },
                    {
                        name: "anchor",
                        text: "URL",
                        mapping: {
                            type: PropertyMappingType.LinkWizard,
                        },
                    },
                    {
                        name: "children",
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        text: "Buton Yazısı",
                        default: "Button Text"
                    },
                    {
                        name: "spacing",
                        mapping: {
                            type: PropertyMappingType.Object,
                            oneOf: ButtonSpacingOneOf,
                        },
                        text: "Boşluklandırma",
                        default: "default"
                    },
                    {
                        name: "isLoading",
                        mapping: {
                            type: PropertyMappingType.Boolean,
                        },
                        text: "Yükleniyor Mu?",
                        default: false,
                    },
                    {
                        name: "isDownload",
                        mapping: {
                            type: PropertyMappingType.Boolean,
                        },
                        text: "İndirme Linki Mi?",
                        default: false,
                    }]
            },
        },
    ];
}
